// @flow
export { default } from './BrandComment';



// WEBPACK FOOTER //
// ./src/components/brand/BrandComment/index.js